import api from '../api';
import { AUTHORIZATIONTOKEN } from '../../consts/services';

export const getAllStoresByBrandId = async (brandId) => {
  const response = await api.get(`/stores/${brandId}` , {
    headers: { 'authorization': AUTHORIZATIONTOKEN }
  });

  return response.data;
}